'use strict';

var es7 = require('./node_modules/es-abstract/es7.js');
var index$1 = require('../has/src/index.js');
var index = require('../function-bind/index.js');

var ES = es7;
var has = index$1;
var bind = index;
var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);

var implementation = function values(O) {
	var obj = ES.RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if (has(obj, key) && isEnumerable(obj, key)) {
			vals.push(obj[key]);
		}
	}
	return vals;
};

module.exports = implementation;
